import React from 'react';
import { Box, Button, Grid, Paper, Stack, Typography } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import ScienceIcon from '@mui/icons-material/Science';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { BasicCodeCombo } from '../core/BasicCodeCombo';

type Props = {
  scenario: string;
  scenarios: any[];
  loading?: boolean;
  onScenarioChange: (code: string) => void;
  onRefresh: () => void;
  onRunSensitivity?: () => void;
  onOpenImport?: () => void;
};

class BieWorkbenchFilterBar extends React.Component<Props> {
  render() {
    const { scenario, scenarios, loading, onRunSensitivity, onRefresh, onOpenImport, onScenarioChange } = this.props;
    return (
      <Paper elevation={1} sx={{ p: 2, mb: 3 }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'stretch', md: 'center' }}
          spacing={2}
          sx={{ mb: 2 }}
        >
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
              BIE Simulator Controls
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Select a scenario, refresh dashboard metrics, and run simulator
              analysis.
            </Typography>
          </Box>
          <Stack direction="row" spacing={1} flexWrap="wrap">
            <Button
              variant="outlined"
              startIcon={<RefreshIcon />}
              onClick={onRefresh}
              disabled={loading}
            >
              Refresh
            </Button>
            {onRunSensitivity && (
              <Button
                variant="outlined"
                startIcon={<ScienceIcon />}
                onClick={onRunSensitivity}
                disabled={loading}
              >
                Sensitivity
              </Button>
            )}
            {onOpenImport && (
              <Button
                variant="contained"
                startIcon={<FileUploadIcon />}
                onClick={onOpenImport}
                disabled={loading}
              >
                Import
              </Button>
            )}
          </Stack>
        </Stack>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 4 }}>
            <BasicCodeCombo
              label="Scenario"
              items={scenarios || []}
              value={scenario || ''}
              onChange={(v: string) => onScenarioChange(String(v || '').toUpperCase())
              }
              disabled={loading}
            />
          </Grid>
        </Grid>
      </Paper>
    );
  }
}
export default BieWorkbenchFilterBar;
